export enum AuthType {
  SIGN_IN = 'SIGN_IN',
  SIGN_UP = 'SIGN_UP',
}
